import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAnalytics } from '../analytics';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const AnalyticsNextJSPageTracker = () => {
  const router = useRouter();
  const analytics = useAnalytics();
  useEffect(() => {
    analytics.trackPage();
  }, [analytics]);
  useEffect(() => {
    const handler = () => {
      analytics.trackPage();
    };
    router.events.on('routeChangeComplete', handler);
    return () => {
      router.events.off('routeChangeComplete', handler);
    };
  }, [router.events, analytics]);
  return /*#__PURE__*/_jsx(_Fragment, {});
};